import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PayrollDetailEditModeSearchSchema } from '../../-shared/payroll-detail-edit-mode-search-schema';
export const Route = createFileRoute('/_staff/payroll-engine-mock/_layout/payroll-units/$unitId/')({
  validateSearch: zodValidator(PayrollDetailEditModeSearchSchema)
});